import React from 'react';
import LoadingMessages from './LoadingMessages';

const LoaderInitial = () => {
	return (
		<div>
			<LoadingMessages />
		</div>
	);
};

export default LoaderInitial;
